import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const KVRow = styled('div')<{ isGridLayout?: boolean }>(({ isGridLayout, theme }) => ({
  paddingBottom: theme.spacing(1),

  ...(isGridLayout
    ? {
        display: 'grid',
        gridTemplateColumns: '225px 1fr',
        alignItems: 'center',
        gap: theme.spacing(1),

        paddingTop: theme.spacing(1),

        [theme.breakpoints.down('sm')]: {
          gridTemplateColumns: '1fr',
        },
      }
    : {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        width: '100%',
      }),
}));

export const Label = styled(Typography)({
  fontWeight: 600,
});

export const Value = styled(Typography)({
  flex: 1,
  wordBreak: 'break-word',
  maxWidth: 175,
  cursor: 'pointer',
});
